// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Button, Grid } from 'semantic-ui-react';
import { format } from 'date-fns';
import DateFNSPT from 'date-fns/locale/pt';
// localdatetime
// views
import Page from 'app/ui/pages/Page';
import TableOxigen from './TableOxigen';
import GraficPrescrition from './GraficPrescription';
import PressureBar from 'app/ui/pages/monitor/PressureBar';
import PatientModal from 'app/ui/modal/PatientModal';
import EnablePatientModal from 'app/ui/modal/EnablePatientModal';
import DisablePatientModal from 'app/ui/modal/DisablePatientModal';
import PatientDeactivateError from 'app/ui/modal/PatientDisableErrorModal';
// css
import './PatientDetails.css';
// lib
import t from 'app/lib/i18n';
// actions
import { openUpdate, TYPE } from 'app/redux/actions/modal';
import { detail, back, openMap } from 'app/redux/actions/patientDetails';
import { openModal as openInitModal } from 'app/redux/actions/patient/enableModal';
import { openModal as openDeinitModal } from 'app/redux/actions/patient/disableModal';
import { updateView, updateMapParams } from 'app/redux/actions/monitor';
// consts
import { STATUS } from 'salvus-shared/consts/patient';
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { TYPE as DEVICE_TYPE } from 'salvus-shared/consts/device';
import { PROFILE } from 'salvus-shared/consts/account';

class PatientDetails extends Component {
    componentDidMount = () => this.loadPage();

    loadPage = () => this.props.dispatch(detail(this.props.match.params.id));

    onClickBack = () => this.props.dispatch(back());

    onClickEdit = () => this.props.dispatch(openUpdate(TYPE.PATIENT, this.props.patientDetail.data, this.loadPage));

    onClickEnable = () => this.props.dispatch(openInitModal(this.props.patientDetail.data, this.loadPage));

    onClickDisable = () => this.props.dispatch(openDeinitModal(this.props.patientDetail.data, this.loadPage));

    renderActivateButton(status) {
        const initializedPatient = status === STATUS.INITIALIZED;
        const deactivatedPatient = status === STATUS.DEACTIVATED;

        if (!initializedPatient) {
            return <Button onClick={this.onClickEnable} content={deactivatedPatient ? 'Reativar' : 'Iniciar'} />;
        }

        return <Button onClick={this.onClickDisable} content="Desativar" />;
    }

    toMap = (patient) => e => {
        e.preventDefault();
        e.stopPropagation();

        const latitude = patient.device.latitude ? patient.device.latitude : patient.latitude;
        const longitude = patient.device.longitude ? patient.device.longitude : patient.longitude;
        const center = { lat: latitude, lng: longitude };
        const zoom = 15;

        this.props.dispatch(updateView('map'));

        if (latitude && longitude) this.props.dispatch(updateMapParams({ center, zoom }));

        this.props.dispatch(openMap());
    }

    renderCylinders(cylinders, cylinderSize) {
        if (cylinders.length === 0) {
            return 'Sem cilindros.';
        }
        return cylinders.map(function(cylinder, cIndex) {
            const key = `c-${cylinder.id}-${cIndex}`;
            return <PressureBar key={key} state={cylinder.state} pressure={cylinder.pressure} cylinderSize={cylinderSize} />;
        });
    }

    renderDetails(patient) {
        const strAddress = `${patient.address}, ${patient.number} ${patient.complement === undefined ? '' : patient.complement} - ${patient.district}, ${
            patient.city
        }/${patient.state}`;
        const strPhone = [patient.phone1, patient.phone2, patient.phone3].filter(p => p && p.length > 0).join(' / ');
        const createdAt = format(patient.createdAt, 'DD/MM/YYYY', { locale: DateFNSPT });
        const lastActiveAt = patient.lastActiveAt ? format(patient.lastActiveAt, 'DD/MM/YYYY', { locale: DateFNSPT }) : '-';
        
        return (
            <React.Fragment>
                <div className="page-header">
                    <div>
                        <Icon name="angle left" className="btn-back" onClick={this.onClickBack} />
                        <div className="page-title">{patient.name}</div>
                    </div>
                    {!(this.props.auth.account.client.type === CLIENT_TYPE.SALVUS && this.props.auth.account.profile === PROFILE.DEFAULT) && (
                        <div>
                            {this.renderActivateButton(patient.status)}
                            <Button content="Editar" onClick={this.onClickEdit} />
                            <Button content="Mapa" onClick={this.toMap(patient)}/>
                        </div>
                    )}
                </div>
                <div className="header">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width="3">
                                <div>
                                    Atendimento: <span className="bold">{patient.serviceNumber}</span>
                                </div>
                                <div>
                                    Tipo: <span className="bold">{t(`patient_period_type_${patient.periodType}`)}</span>
                                </div>
                                <div>
                                    CPF: <span className="bold">{patient.cpf}</span>
                                </div>
                                {patient.rg && (
                                    <div>
                                        RG: <span className="bold">{patient.rg}</span>
                                    </div>
                                )}
                            </Grid.Column>
                            <Grid.Column width="7">
                                <div>
                                    Endereço: <span className="bold wrap">{strAddress}</span>
                                </div>
                                <div>
                                    CEP: <span className="bold wrap">{patient.zipCode}</span>
                                </div>
                                <div>
                                    Telefone(s): <span className="bold">{strPhone}</span>
                                </div>
                                <div>
                                    Tipo de Cilindro:{' '}
                                    <span className="bold">
                                        {patient.cylinderSize}m<sup>3</sup>
                                    </span>
                                </div>
                            </Grid.Column>
                            <Grid.Column width="4">
                                <div>
                                    Plano de Saúde: <span className="bold wrap">{patient.healthInsurence}</span>
                                </div>
                                <div>
                                    Fornecedor: <span className="bold wrap">{patient.supplier.name}</span>
                                </div>
                                <div>
                                    Paciente cadastrado desde: <span className="bold">{createdAt}</span>
                                </div>
                                <div>
                                    Início da última ativação: <span className="bold">{lastActiveAt}</span>
                                </div>
                            </Grid.Column>
                            <Grid.Column width="4" />
                        </Grid.Row>
                    </Grid>
                </div>
                <div className="body">
                    <Grid id="cylinder">
                        <Grid.Row>
                            <Grid.Column width="3" id="column-detail">
                                { patient.device.type === DEVICE_TYPE.CONCENTRATOR ? <div className="grid-title">CONCENTRATOR</div> : <div className="grid-title">CILINDROS</div> }
                                { patient.device.type !== DEVICE_TYPE.CONCENTRATOR && <div className="cylinder-list">{this.renderCylinders(patient.cylindersList, patient.cylinderSize)}</div> }
                                { patient.device.type !== DEVICE_TYPE.CONCENTRATOR && <div className="grid-title">CILINDROS CONSUMIDOS</div>} 
                                { patient.device.type !== DEVICE_TYPE.CONCENTRATOR  &&
                                <div className="cylinder-info">
                                    <div className="title">Última ativação:</div> <div className="value">{patient.numberOfChangesLastActive}</div>
                                </div> } 
                                { patient.device.type !== DEVICE_TYPE.CONCENTRATOR &&
                                <div className="cylinder-info">
                                    <div className="title">Total:</div> <div className="value">{patient.numberOfChangesTotal}</div>
                                </div> }
                                <Grid id="grid-flow">
                                    <Grid.Row>
                                        <Grid.Column width="8">
                                            <div className="title">
                                                PRESCRIÇÃO
                                                <br />
                                                (L/min)
                                            </div>
                                            <div className="value">{patient.prescription}</div>
                                        </Grid.Column>
                                        <Grid.Column width="8">
                                            <div className="title">
                                                FLUXO
                                                <br />
                                                (L/min)
                                            </div>
                                            <div className="value">{patient.flow === '-' ? '--' : patient.flow.toFixed(2)}</div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width="9" id="column-history" className="no-padding">
                                <div className="grid-title">Histórico de Consumo</div>
                                <TableOxigen cylinderSize={patient.cylinderSize} data={patient.consumptionHistory} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Grid id="cylinder">
                        <Grid.Row>
                            <Grid.Column width="3" id="column-detail" className="column-detail-prescription">
                                <div className="grid-title">HISTORICO DE PRESCRIÇÂO</div>
                                <Grid id="grid-flow" textAlign="center">
                                    <Grid.Row>
                                        <Grid.Column width="10">
                                            <div className="title">DATA</div>
                                        </Grid.Column>
                                        <Grid.Column width="6">
                                            <div className="title">PRESCRIÇÃO (L/Min)</div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid id="prescription-body">
                                        {patient.prescriptions.map(presc => {
                                            return (
                                                <Grid.Row width="16" key={presc.id}>
                                                    <Grid.Column width="11">{format(new Date(presc.date), 'DD/MM/YYYY HH:mm:ss')}</Grid.Column>
                                                    <Grid.Column width="5">{`${presc.prescription}`}</Grid.Column>
                                                </Grid.Row>
                                            );
                                        })}
                                        <Grid.Row width="16">
                                            <Grid.Column width="11" />
                                            <Grid.Column width="5" />
                                        </Grid.Row>
                                    </Grid>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width="9" id="column-history-grafic" className="no-padding">
                                <div className="grid-title">Comparação Consumo vs Prescrição</div>
                                <GraficPrescrition data={patient.prescriptions} flows={patient.flows} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
                <PatientModal />
                <EnablePatientModal />
                <DisablePatientModal />
                <PatientDeactivateError />
            </React.Fragment>
        );
    }

    render() {
        const { loading, data } = this.props.patientDetail;
        return (
            <Page id="page-patient-details" loading={loading}>
                {data ? this.renderDetails(data) : null}
            </Page>
        );
    }
}

PatientDetails.propTypes = {
    auth: PropTypes.object,
    patientDetail: PropTypes.object,
    match: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    patientDetail: state.patientDetail,
});
export default connect(mapStateToProps)(PatientDetails);
